export default "__VITE_ASSET__Cqeb2kxV__"